module.exports = __webpack_public_path__ + "media/logos/DGESUM-fcbd06e4.png";